module.exports = __webpack_public_path__ + "static/img/wbz965bb.d256726.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/wbz965bb.jpg
// module id = OsiQ
// module chunks = 0